import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-074d4667"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "field-group",
  "data-group": "1"
}
const _hoisted_2 = { class: "field" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-notify" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isAuthenticated ? _ctx.$emit('saveTemplate') : _ctx.toggleAuthModal())),
        class: "btn btn-blue-gradient btn--w-icon",
        disabled: _ctx.isDisabled ? 'disabled' : null
      }, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t("search.save_template_btn")), 1)
      ], 8, _hoisted_3)
    ])
  ]))
}